{
  "removeButtonLabel": "Eltávolítás",
  "removeDescription": "Nyomja meg a Delete billentyűt a címke eltávolításához."
}
